import { INavData } from "@coreui/angular";

export const navItems: INavData[] = [
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "cil-speedometer",
  },

  {
    name: "Reports",
    url: "/reports",
    icon: "cil-line-style",
    children: [
      {
        name: "Day Book Report",
        url: "/dailyreport",
        icon: "cil-calendar",
      },
      {
        name: "Dairy Invoice Entry",
        url: "/inventory/dairy-invoice-entry",
        icon: "cil-file",
      },
      {
        name: "Local Sale Report",
        url: "/salesreport",
        icon: "cil-cash",
      },
      {
        name: "PayOut Reports",
        url: "/payoutreport",
        icon: "cil-wallet",
      },
      {
        name: "Statement Reports",
        url: "/milkTransactionreport",
        icon: "cil-drop",
      },
      {
        name: "Variance Shiftswise Report",
        url: "/variance-shiftwise",
        icon: "cil-chart-line",
      },
      // {
      //   name: "Bank Reports",
      //   url: "/bankreports",
      //   icon: "cil-credit-card",
      // },
      {
        name: "Recoveries Report",
        url: "/recoveries-report",
        icon: "cil-notes",
      },
    ],
  },

  {
    name: "Producer Reports",
    url: "/producer-reports",
    icon: "cil-people",
    children: [
      {
        name: "Producer Day Wise",
        url: "/producer-reports/day-wise",
        icon: "cil-calendar",
      },
      {
        name: "Producer Passbook",
        url: "/producer-reports/passbook",
        icon: "cil-book",
      },
      {
        name: "Producer Bank Report",
        url: "/producer-reports/bank-report",
        icon: "cil-bank",
      },
    ],
  },

  {
    name: "Agent Reports",
    url: "/agent-reports",
    icon: "cil-address-book",
    children: [
      {
        name: "Agent Bank Report",
        url: "/agent-reports/bank-report",
        icon: "cil-bank",
      },
      {
        name: "Agent Consolidated",
        url: "/inventory/AgentConsolidated",
        icon: "cil-chart",
      },
      {
        name: "Agent Day Wise",
        url: "/agent-reports/day-wise",
        icon: "cil-calendar",
      },
    ],
  },

  {
    name: "Bcc",
    url: "/bcc",
    icon: "cil-drop",
    children: [
      {
        name: "Milk Collection Statement",
        url: "/bcc/milk-collection-statement",
        icon: "cil-drop",
      },
        {
      name: "Day Wise Milk Statement",
      url: "/bcc/daywise-periodic-statement",
      icon: "cil-calendar",
    },
    ],
  },

  {
    name: "Registration",
    url: "/registration",
    icon: "cil-user",
    children: [
      {
        name: "Producer Registration",
        url: "/producer-registration",
        icon: "cil-user",
      },
      {
        name: "Society Registration",
        url: "/society-registration",
        icon: "cil-building",
      },
      // ✅ BCC Registration — NEW
      {
        name: "BCC Registration",
        url: "/bcc-registration",
        icon: "cil-location-pin",
      },
    ],
  },

  {
    name: "Indent",
    url: "/producer-requirement-indents",
    icon: "cil-list",
  },
];